import { BUXUS_MAKE_REQUEST_URL } from '../../platform/abp/config'
import { httpJson } from '../../platform/abp/httpClient'

/** Zoho Creator / Buxus API success code (BuxusConsts.ApiResponseCodeSuccess). */
const BUXUS_API_SUCCESS_CODE = 3000

export type MakeARequestPayload = {
  requestType: string
  requestDetails?: string
  operatorId: string
  request: string
}

export type MakeARequestResponse = {
  code?: number
  Code?: number
  error?: string[] | null
  Error?: string[] | null
}

type AbpWrappedResponse = MakeARequestResponse & {
  result?: MakeARequestResponse
}

function unwrapMakeARequestResponse(response: unknown): MakeARequestResponse {
  if (!response || typeof response !== 'object') return {}
  const wrapped = response as AbpWrappedResponse
  if (wrapped.result && typeof wrapped.result === 'object') return wrapped.result
  return wrapped
}

export async function submitMakeARequest(payload: MakeARequestPayload): Promise<MakeARequestResponse> {
  const raw = await httpJson<unknown>(BUXUS_MAKE_REQUEST_URL, {
    method: 'POST',
    auth: true,
    body: payload,
  })
  return unwrapMakeARequestResponse(raw)
}

/** Mirrors mobile `RequestFormScreen`: success when no error payload; Zoho uses code 3000. */
export function makeARequestSucceeded(response: unknown): boolean {
  const r = unwrapMakeARequestResponse(response)
  const errors = r.error ?? r.Error
  if (Array.isArray(errors) && errors.some((e) => typeof e === 'string' && e.trim())) {
    return false
  }
  const code = r.code ?? r.Code
  if (code === undefined) return true
  return code === 0 || code === BUXUS_API_SUCCESS_CODE
}

export function makeARequestErrorMessage(response: unknown): string | null {
  const r = unwrapMakeARequestResponse(response)
  const errors = r.error ?? r.Error ?? []
  if (Array.isArray(errors)) {
    const first = errors.find((e) => typeof e === 'string' && e.trim())
    if (first) return first
  }
  return null
}
